// Shared constants and helpers for GetYourGuide integrations.
// Consumed by gyg-activity-widget and gyg-experiences-section.

export const GYG_SHOW_ALL_BASE = 'https://www.getyourguide.com/s/'

// GYG does not support regional German variants or all IETF locales — map to nearest supported.
export const GYG_LOCALE_MAP: Record<string, string> = {
    'de-AT': 'de-DE',
    'de-CH': 'de-DE',
    'hr-HR': 'en-GB',
}

export const toGygLocale = (locale: string): string => GYG_LOCALE_MAP[locale] ?? locale
